import { TCModel, TCString, GVL } from '@iabtcf/core';
import { CmpApi } from '@iabtcf/cmpapi';

window.TCString = TCString;
GVL.baseUrl = 'https://static-assets.rp-online.de/consent/';
window.TCModel = new TCModel(new GVL());
window.CmpApi = new CmpApi(28, 1, false);
window.CmpApi.update(window.park.cookie.get('eupubconsent-v2'));



// WEBPACK FOOTER //
// ./src/widgets/cmp.js